export default {
    id: null,
    type_id: "",
    description: "",
    volume_cap: "",
    weight_cap: ""
}